import { useAuth } from '../../contexts/AuthContext';
import { PageHeader } from '../../components/common/PageHeader';
import { TeamsManager } from '../../components/teams/TeamsManager';

export function OrgTeamsPage() {
  const { user } = useAuth();
  const orgId = user?.orgId ?? '';
  const canManage = (user?.roles?.includes('org_owner') ?? false) || (user?.superAdmin ?? false);

  return (
    <>
      <PageHeader
        title="Teams"
        subtitle="Group reps into teams and assign managers who oversee them."
      />
      <TeamsManager orgId={orgId} canManage={canManage} />
    </>
  );
}
